var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 16,
    height: 16,
    rx: 8,
    transform: "rotate(180 16 16)",
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8033 8.47065C11.0656 8.21033 11.0656 7.78758 10.8033 7.52727L7.44694 4.19524C7.18472 3.93492 6.75888 3.93492 6.49666 4.19524C6.23445 4.45555 6.23445 4.8783 6.49666 5.13862L9.37897 8L6.49876 10.8614C6.23654 11.1217 6.23654 11.5444 6.49876 11.8048C6.76098 12.0651 7.18682 12.0651 7.44904 11.8048L10.8054 8.47273L10.8033 8.47065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightButton);
export default __webpack_public_path__ + "static/media/right_button.4c735d9efd932a0e51b975900ed95d25.svg";
export { ForwardRef as ReactComponent };